// extracted by mini-css-extract-plugin
export default {"red":"red__ZAcOm","green":"green__E3lgf","label":"label__SJT4n"};